import * as Accordion from '@radix-ui/react-accordion';
import { HiOutlineChevronDown } from 'react-icons/hi'
import { BsExclamationCircle } from 'react-icons/bs'
import { OrganizationSettingsTranslations } from '../../types'
import { Text } from '../CreateContribution/formComponents/FormComponents'
import { TextEditor } from '../common/TextEditor'


type Props = {
  languages: OrganizationSettingsTranslations
  onTranslationUpdate: Function
  translationFunction: Function
}
export const OrganizationTranslations = ({ languages, onTranslationUpdate, translationFunction }: Props) => {


  const handleFormUpdate = (lang: string, key: string, value: string) => {
    onTranslationUpdate(lang, key, value)
  }

  const _hanldeKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const translationSection = () => {
    let entries = Object.entries(languages)
    return entries.map(l => {
      return (
        <Accordion.Item value={l[0]} className="create-collection-accordion-item " key={l[0]}>
          <Accordion.Header className="create-collection-accordion-header">
            {l[1].required ? (
              <div>
                {l[0]}
                <BsExclamationCircle style={{ marginLeft: '10px' }} />
              </div>
            ) : l[0]}
            <Accordion.Trigger className="create-collection-accordion-trigger" >
              <HiOutlineChevronDown className="create-collection-accordion-trigger-icon" />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="create-collection-accordion-content">
            <form onSubmit={e => {
              e.preventDefault()
            }} name="createCollectionForm">
              <fieldset>
                <Text
                  title={translationFunction('ADMIN.EDIT_ORGANIZATION.FIELD_DESCRIPTION')}
                  name="description"
                  placeholder={translationFunction('ADMIN.EDIT_ORGANIZATION.FORM_DESCRIPTION')}
                  onUpdate={(name: string, newValue: string) => handleFormUpdate(l[0], name, newValue)}
                  handleKeyDown={_hanldeKeyDown}
                  value={l[1].description} />
                <div className="field-pair">
                  <label htmlFor={"title"}>{translationFunction('ADMIN.EDIT_ORGANIZATION.FIELD_ABOUT')}</label>
                  <TextEditor
                    initialValue={l[1].about}
                    onChange={(newValue: string) => { handleFormUpdate(l[0], "about", newValue) }}
                  />
                </div>
                <div className="field-pair">
                  <label htmlFor={"title"}>{translationFunction('ADMIN.EDIT_ORGANIZATION.FIELD_TERMS')}</label>
                  <TextEditor
                    initialValue={l[1].terms}
                    onChange={(newValue: string) => { handleFormUpdate(l[0], "terms", newValue) }}
                  />
                </div>
              </fieldset>
            </form>
          </Accordion.Content>
        </Accordion.Item>
      )
    })
  }

  return (
    <div className="edit-organization-translations-section">
      <h2>{translationFunction('ADMIN.EDIT_ORGANIZATION.TRANSLATIONS_TITLE')}</h2>
      <Accordion.Root type="multiple" className="create-collection-accordion-root">
        {translationSection()}
      </Accordion.Root>
    </div>
  )

}
